<template>
  <div class="itemlist">
    <v-card>
      <v-card-title>
        <!-- img src="../../../static/images/icon8icons/icons8-paint-palette-50.png" / -->
        <h1>Naloxone Locations</h1>
        <v-spacer/>

        <v-btn @click='addLocation' color="accent">Add Location</v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="computedLocations"
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr @click="viewLocation(props.item)" style="cursor: pointer">
            <td class="body-2 text-xs-left">{{ props.item.id }}</td>
            <td class="body-2 text-xs-left">{{ formatDate(props.item.lastUpdate) }}</td>
            <td class="body-2 text-xs-left">{{ props.item.name }}</td>

            <td v-if="props.item.medicinePresent" class="body-2 text-xs-left">
                <v-icon class="success--text">check_circle</v-icon>
            </td>
            <td v-else class="body-2 text-xs-left">
                <v-icon class="error--text">cancel</v-icon>
            </td>

            <td v-if="!expired(props.item.expirationDate)" class="body-2 text-xs-left">
                <v-icon class="success--text">check_circle</v-icon>
            </td>
            <td v-else class="body-2 text-xs-left">
                <v-icon class="error--text">cancel</v-icon>
            </td>

            <td class="text-xs-right">
                      <v-icon
                        small
                        class="mr-2"
                        @click.stop='editLocation(props.item)'
                      >
                        edit
                      </v-icon>
                      <v-icon
                        small
                        @click.stop="deleteLocation(props.item)"
                      >
                        delete
                      </v-icon>
                    </td>
          </tr>
        </template>
      </v-data-table>
      <div class="error--text" v-if="errMessage != null">
        {{errMessage}}
      </div>

    </v-card>
      <hr />

    <!-- Delete confirmation dialog -->
    <v-dialog v-model="deleteDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Delete Location</v-card-title>
          <v-card-text>Are you sure you want to delete this location ({{ getName(currentLocation) }})?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="deleteDialog = false">Do not delete</v-btn>
            <v-btn color="green darken-1" flat :loading="inProgress" @click="reallyDeleteLocation">Delete it!</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

</div>

</template>

<script>
import {mapState} from 'vuex'
import firebase from 'firebase/app'

import utils from '../utils.js'
//import ReturnToDashboard from './ReturnToDashboard'

export default {
  name: 'LocManager',
  components: {

  },
  data () {
    return {
      inProgress: false,
      loading: false,
      errMessage: null,
      deleteDialog: false,
      currentLocation: null,
      headers: [
        // {text: 'Category', value: 'category', align: 'left'},
        {text: 'ID', value: 'id', align: 'left'},
        {text: 'Last updated', value: 'lastUpdated', align: 'left'},
        {text: 'Name', value: 'name', align: 'left'},
        {text: 'Present', value: 'lat', align: 'left'},
        {text: 'Not Expired', value: 'lat', align: 'left'},
        {text: 'Actions', value: '', align: 'right'}
      ]
    }
  },
  computed: {
    ...mapState({
      locations: state => state.locations.locations,
    }),
    computedLocations: function () {
      const newItems = this.locations
      return newItems
    }

  },
  mounted: function () {
    // console.log('ITEMS: ' + this.items)
    // console.log('ComputedITEMS: ' + JSON.stringify(this.computedItems))
    if (firebase.auth().currentUser && firebase.auth().currentUser != null) {
        this.$store.dispatch('locations/loadUid', firebase.auth().currentUser)
    } else {
        console.error("Error: No user in LocManager")
    }
  },
  methods: {

    getName: function (loc) {
        if (loc && loc.name) {
            return loc.name
        } else {
            return "No Location"
        }
    },
    formatDate: function (d) {
        return utils.formatDateFromMilliseconds(d)
    },
    deleteLocation: function (location) {
      this.errMessage = null
      this.currentLocation = location
      this.deleteDialog = true
    },
    reallyDeleteLocation: async function () {
      try {
          this.inProgress = true
          await utils.deleteLocation(this.currentLocation)
      } catch (err) {
        this.errMessage = err.message
      }
      this.inProgress = false
      this.deleteDialog = false;
    },
    editLocation: function (location) {
      this.$store.commit('locations/setActiveLocation', location)
      this.$router.push({name: 'AddEditLocation'})
    },
    viewLocation: function (location) {
      this.$store.commit('locations/setActiveLocation', location)
      this.$router.push({name: 'ViewLocation'})
    },
    addLocation: function () {
      this.editLocation(null)
    },
    expired: function (expDate) {
        // let rc = expDate < (new Date()).getTime()
        // console.log("DEBUG: checking exp date:"+expDate+"   "+rc)
        return expDate < (new Date()).getTime()
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.itemlist {
  width: 100%;
}

</style>
